import React, { useContext } from 'react';
import { DataTableContext } from './DataTableContext';
import { SortLabel } from '../';
var DataTableHeader = function (_a) {
    var data = _a.data, order = _a.order, columns = _a.columns, orderBy = _a.orderBy, setOrder = _a.setOrder, setOrderBy = _a.setOrderBy, checkboxConfig = _a.checkboxConfig;
    var ctx = useContext(DataTableContext);
    /**
     * sorts the table by column
     * @param column - id of the column
     */
    var sortData = function (column) {
        var isDesc = orderBy === column && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(column);
    };
    return (React.createElement("div", { className: "data-grid-head-container" },
        React.createElement("div", { className: "data-grid", "aria-label": "Data Grid" },
            React.createElement("div", { className: "data-grid-head" },
                React.createElement("div", { className: "data-grid-row" }, columns.filter(function (c) { return typeof c !== 'undefined'; }).map(function (column, index) {
                    if (!column.invisible) {
                        var left = 0;
                        if (column.fixed) {
                            left = columns.slice(0, index).reduce(function (sum, v) { return sum + v.width; }, 0);
                        }
                        var headerContent = column.headerTooltip !== false ? (
                        // <Tooltip title={column.label as string} placement="top-start">
                        React.createElement("span", null, column.label)
                        // </Tooltip>
                        ) : column.label;
                        return (React.createElement("div", { key: column.id, "data-column": column.id, "data-min-width": column.width, className: "data-grid-cell " + (column.fixed ? 'fixed-column' : ''), style: { minWidth: column.width, maxWidth: column.width, left: left + 'px', textAlign: column.align || 'left' } },
                            column.sortable ? (React.createElement(SortLabel, { active: orderBy === column.id, direction: orderBy === column.id ? order : 'desc', onClick: function (e) {
                                    sortData(column.id);
                                } }, column.renderHeader ? column.renderHeader() : headerContent)) : column.renderHeader ? column.renderHeader() : headerContent,
                            column.resizable !== false &&
                                React.createElement("div", { className: "resizer" })));
                    }
                    else {
                        return (React.createElement(React.Fragment, null));
                    }
                }))))));
};
export default DataTableHeader;
